import { atom } from "recoil";

/** The tkns panel (balance + top-up packs) */
export const ShowTknsPanelAtom = atom<boolean>({
	key: "ShowTknsPanel",
	default: false,
});

/** null = not fetched yet (or signed out) */
export const TknsBalanceAtom = atom<number | null>({
	key: "TknsBalance",
	default: null,
});

/** current plan from the payments worker; null = not fetched yet */
export const TknsTierAtom = atom<"free" | "plus" | null>({
	key: "TknsTier",
	default: null,
});

/** today/month AI-compute meters from the payments worker */
export const TknsMetersAtom = atom<{
	today: { used: number; cap: number };
	month: { used: number; grant: number };
} | null>({
	key: "TknsMeters",
	default: null,
});
